import Vue from "vue";

export default Vue.observable({
  events: [
    {
      id: 1,
      title: 'My Event',
      startDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 3),
      endDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 2),
      url: '',
      classes: 'event-success',
      label: 'business',
      chatActivators: [{ feature: "classroom", id: "ck1234567890" }]
    },
  ],
  labels: [
    { text: 'Business' ,value : 'business', color: 'success' },
    { text: 'Work', value: 'work', color: 'warning'},
    { text: 'Personal', value: 'personal', color: 'danger'},
  ]
});
